export const CustomReportsI18n = {
  noLinks: "No Links",
  linkedSubmittals: "Linked Submittals",
  linkedActivities: "Linked Activities",
  includesDeliveredMaterials: "Includes Delivered Materials",
  doesNotIncludeDeliveredMaterials: "Does Not Include Delivered Materials"
};

export const LINKED_SUBMITTALS_KEY = "linked_submittals";
export const LINKED_ACTIVITIES_KEY = "linked_activities";
